module.exports = __webpack_public_path__ + "img/eastern-wood-pewee.1a13914d.jpg";